module.exports = __webpack_public_path__ + "static/media/Technical Committee Structure-pdf.19d0a2d6.pdf";